<template>
    <div>
        <headerNav title="授权证书" />
        <!--<img ref="img" class="imghide" src="../../../assets/images/1.jpg" />-->
        <img :src="url" style="width:100%;height:100%"/>
        
    </div>
</template>
<script>

export default {
    data(){
        return {
            url:'',
            width:750,
            height:1250,
            ctx:{},
            canvas:'',
            img: new Image()
        }
    },
    created(){
        this.ajax.post('/api/services/app/PhoneUser/MyCertificateAuthorization').then(x=>{
            this.url=this.$baseurl+x.result;
        })
        // this.url=this.$baseurl+'/Temp/Upload/1.jpg';
        // // let content = document.getElementsByClassName("canv")[0];
        // // this.ctx = this.content.getContext("2d");
        // this.$nextTick(()=>{
            
        //      // 初始化背景图片
        //     this.img.setAttribute('crossOrigin', 'Anonymous')
        //     this.img.src = this.url;
        //     this.img.onerror = (x) => {
        //         console.log(x);
        //         var timeStamp = +new Date()
        //         this.img.src = this.url;
        //     }
        //     this.img.onload=()=>{
        //         this.clean();
        //     }

        // });

       
    },
    methods:{
        clean()
        {
            let content = document.getElementsByClassName("content")[0];
            this.canvas = document.createElement("canvas");
            this.canvas.width = content.clientWidth;
            this.canvas.height = content.clientHeight;
            this.ctx = this.canvas.getContext("2d");
            this.ctx.drawImage(this.img, 0, 0, this.width, this.height)
            this.fillcentertit("我的授权书!",content.clientWidth/2,60);
            this.filltit("兹授权：",50,300);
            this.filltext("发展测试银多多!",140,300);
            this.filltit("微信号：",50,330);
            this.filltext("1234567!",140,330);
            this.filltit("身份证号：",50,360);
            this.filltext("1234567!",140,360);
            this.filltit("授权编号：",50,390);
            this.filltext("1321321564645",140,390);
            this.filltext("20200927",140,450);
            this.filltext("20210927",220,450);
            content.appendChild(this.canvas);
            this.drawInfo = []
            if (this.info && this.info.length !== 0) this.drawWithInfo()
        },
        fillcentertit(text,x,y)
        {
            this.ctx.fillStyle="#0000ff";
            this.ctx.font="30px Arial";
            this.ctx.textAlign="center";
            this.ctx.fillText(text,x,y);
        },
        filltit(text,x,y)
        {
            this.ctx.font="20px Arial";
            this.ctx.textAlign="start";
            this.ctx.fillText(text,x,y);
        },
        filltext(text,x,y)
        {
            this.ctx.font="16px Arial";
            this.ctx.fillText(text,x,y);
        },
        fillmtext(text,x,y)
        {
            this.ctx.font="14px Arial";
            this.ctx.fillText(text,x,y);
        }
    },
    
}
</script>
<style lang="scss" scoped>
 .content{
     position: absolute;
     top:46px;
     left: 0;
     right: 0;
     bottom: 0;
     width: 100%;
     height: 100%;
 }
 .imghide{
     visibility: hidden;
 }
</style>